var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.368 2.908V.872h-3.865v2.036H6.497V.872H2.632v2.036H.562v20.22h22.877V2.908h-2.071zm.121 18.44H2.511V7.911h18.978v13.437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.102 11.347L17.15 9.396l-6.905 6.905-2.953-2.952L5.34 15.3l4.905 4.904z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzMzMzMzMyI+CjxnPgoJPHBhdGggZD0iTTIxLjM2OCwyLjkwOFYwLjg3MmgtMy44NjV2Mi4wMzZINi40OTdWMC44NzJIMi42MzJ2Mi4wMzZoLTIuMDd2MjAuMjJoMjIuODc3VjIuOTA4SDIxLjM2OHogTTIxLjQ4OSwyMS4zNDhIMi41MTFWNy45MTFoMTguOTc4VjIxLjM0OHoiLz4KCTxwb2x5Z29uIHBvaW50cz0iMTkuMTAyLDExLjM0NyAxNy4xNSw5LjM5NiAxMC4yNDUsMTYuMzAxIDcuMjkyLDEzLjM0OSA1LjM0LDE1LjMgMTAuMjQ1LDIwLjIwNCAJIi8+CjwvZz4KPC9zdmc+Cg==";
export { SvgCalendar as ReactComponent };